import { fromJS } from 'immutable'
import {
  LOB_CREATE_REQUEST,
  LOB_CREATE_SUCCESS,
  LOB_CREATE_FAILURE,
  LOB_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LOB_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case LOB_CREATE_SUCCESS:
      return state
        .set('lobCreate', fromJS(action.payload.createdLOB))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case LOB_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('lobCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LOB_CREATE_RESET:
      return state
        .delete('lobCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lob/lob-create-reducer.js